import { Typography } from "antd"
import React from "react"

const Link = ({ children, ...rest }) => {
  return <Typography.Link {...rest}>{children}</Typography.Link>
}

export default Link
